import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import CUIContainer from 'connect-dot-com-ui-components/Components/CUIContainer/CUIContainer';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import Footer from './Footer';
import HomepageHeader from './HomepageHeader';

const HomepageLayout = ({
  children,
  header
}) => {
  return /*#__PURE__*/_jsxs(CUIFlex, {
    direction: "column",
    flex: "1",
    minHeight: "100%",
    children: [/*#__PURE__*/_jsx(HomepageHeader, {
      children: header
    }), /*#__PURE__*/_jsx(CUIContainer, {
      maxW: "1030px",
      flex: "1",
      padding: {
        base: 8,
        sm: 12
      },
      children: children
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

export default HomepageLayout;